import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-button', 'loading', 'Prašome palaukti');
